import { createAsyncAction } from '../reduxActions';

export const fetchCopyEventsAction = createAsyncAction('GET_COPY_EVENTS');

export function fetchCopyEvents(buttonTabIndex = 0, experienceType = 'ALL', filter = '') {
  return { type: fetchCopyEventsAction.toString(), filter, experienceType, buttonTabIndex };
}
